/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Target_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Target Event Group" |
*
* @param {Live_Caption_Target_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_target_event_group = /** @type {((inputs?: Live_Caption_Target_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Target_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'événements cibles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielgruppe der Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Target Event Group")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая группа мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo objetivo del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象イベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य घटना समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos Alvo")
	return /** @type {LocalizedString} */ ("Target Event Group")
});